import { getLocalizedName } from '../../../../helpers';
import FileDeliveryService from '../../../../apiclients/FileDeliveryService';
import ContentService from '../../../../apiclients/ContentService';
import * as shortid from 'shortid';
import AppContext from '../../../../AppContext';
import { ImageIcon, ContentIcon, VideoIcon, FileIcon } from '../../../Search/Search';
class MeetingsAndCollectionsController {
    getMeetings = async () => {
        return await this.getContents('meetings');
    };

    getCollections = async () => {
        return await this.getContents('collections');
    };

    getContents = async (objectType) => {
        let appContext = new AppContext();
        let currentUserSub = appContext.getMyInfo().userSub;
        let data = await FileDeliveryService.getContent(`user-${objectType}-${currentUserSub}`, undefined, undefined);

        let contentIds;
        if (objectType === 'collections') {
            contentIds = Object.keys(data.col);
        } else {
            contentIds = Object.keys(data.mtg);
        }
        // console.log(objectType + ' Ids', contentIds);
        let contents = [];
        for (let i = 0; i < contentIds.length; i++) {
            let colId = contentIds[i];
            try {
                //     console.log('hey', colId);
                let collection = await FileDeliveryService.getContent(colId, undefined, { active: true, ttl: 30000 });
                contents.push(collection);
            } catch (err) {
                console.log(err);
            }
        }
        // console.log(objectType, contents);
        return contents;
    };

    createCOLSectionStructure = (collectionData, language) => {
        // let appContext = new AppContext();
        // let platformConfig = appContext.getPlatformConfig();
        // let headerStyle = platformConfig.colHeaderStyle;
        let sections = [
            {
                sectionType: 'Container',
                id: shortid(),
                properties: {
                    columns: 1,
                },
                sections: [
                    {
                        sectionType: 'Container',
                        images: { image: [collectionData.previewImage] },
                        properties: {
                            columns: 1,
                            containerPadding: '0px',
                            itemsSpacing: '0px',
                            border: false,
                            borderColor: '#000',
                            background: false,
                            edgeToEdge: true,
                            images: [],
                            width: 100,
                            row: 0,
                            paddingLeft: true,
                            paddingTop: true,
                            paddingRight: true,
                            paddingBottom: true,
                            minimumHeight: 200,
                        },
                        sections: [],
                        id: shortid(),
                    },
                    {
                        sectionType: 'Container',
                        images: { image: [] },
                        id: shortid(),
                        properties: {
                            columns: 1,
                            containerPadding: '0px',
                            itemsSpacing: '0px',
                            border: false,
                            borderColor: '#000',
                            background: false,
                            edgeToEdge: false,
                            images: [],
                            width: 100,
                            row: 1,
                            paddingLeft: true,
                            paddingTop: true,
                            paddingRight: true,
                            paddingBottom: true,
                        },
                        sections: [
                            {
                                sectionType: 'Text',
                                text: { text: `<h2 class="pdc-text-center">${collectionData.name}</h2>` },
                                documents: {},
                                images: {},
                                properties: {
                                    padding: '20px',
                                    color: '#000',
                                    paddingLeft: true,
                                    paddingTop: true,
                                    paddingRight: true,
                                    paddingBottom: true,
                                    width: 100,
                                    row: 0,
                                    style: 'standardBig',
                                },
                                id: shortid(),
                            },
                            {
                                sectionType: 'Text',
                                text: { text: `<p></p>` },
                                documents: {},
                                images: {},
                                properties: {
                                    padding: '0px',
                                    color: '#000',
                                    paddingLeft: true,
                                    paddingTop: true,
                                    paddingRight: true,
                                    paddingBottom: true,
                                    width: 100,
                                    row: 0,
                                    style: 'st',
                                },
                                id: shortid(),
                            },
                            {
                                sectionType: 'Spacer',
                                text: {},
                                documents: {},
                                images: {},
                                properties: {
                                    size: 's',
                                    border: false,
                                    borderColor: '#000',
                                    background: false,
                                    width: 100,
                                    row: 2,
                                },
                                id: shortid(),
                            },
                            this.createFileAndContentSectionsNew(collectionData.resources, language), //this.createFileAndContentSections(collectionData.resources, language),
                            {
                                sectionType: 'Spacer',
                                text: {},
                                documents: {},
                                images: {},
                                properties: {
                                    size: 'm',
                                    border: false,
                                    borderColor: '#000',
                                    background: false,
                                    width: 100,
                                    row: 2,
                                },
                                id: shortid(),
                            },
                            {
                                sectionType: 'Text',
                                text: { text: `<p></p>` },
                                documents: {},
                                images: {},
                                properties: {
                                    padding: '0px',
                                    color: '#000',
                                    paddingLeft: true,
                                    paddingTop: true,
                                    paddingRight: true,
                                    paddingBottom: true,
                                    width: 100,
                                    row: 0,
                                    style: 'st',
                                },
                                id: shortid(),
                            },
                            {
                                sectionType: 'Spacer',
                                text: {},
                                documents: {},
                                images: {},
                                properties: {
                                    size: 's',
                                    border: false,
                                    borderColor: '#000',
                                    background: false,
                                    width: 100,
                                    row: 2,
                                },
                                id: shortid(),
                            },
                            {
                                sectionType: 'Gallery',
                                text: {},
                                documents: {},
                                images: {
                                    images: this.getAllImageIds(collectionData.resources),
                                },
                                properties: {
                                    size: 'cover',
                                    relativeSize: 'L',
                                    columnsWidth: '25%',
                                    align: 'left',
                                    contentAlign: 'center center',
                                    padding: '0px',
                                    carousel: false,
                                    width: 100,
                                    row: 11,
                                },
                                id: shortid(),
                            },
                        ],
                    },
                ],
            },
        ];
        return sections;
    };

    createMTGSectionStructure = (collectionData, language) => {
        let date = collectionData.date.toDate();
        let locale = language;
        let month = date.toLocaleString(locale, { month: 'long' });
        let year = date.getFullYear();

        let sections = [
            {
                sectionType: 'Container',
                id: shortid(),
                properties: {
                    columns: 1,
                },
                sections: [
                    {
                        sectionType: 'Container',
                        images: { image: [collectionData.previewImage] },
                        properties: {
                            columns: 1,
                            containerPadding: '0px',
                            itemsSpacing: '0px',
                            border: false,
                            borderColor: '#000',
                            background: false,
                            edgeToEdge: true,
                            images: [],
                            width: 100,
                            row: 0,
                            paddingLeft: true,
                            paddingTop: true,
                            paddingRight: true,
                            paddingBottom: true,
                            minimumHeight: 200,
                        },
                        sections: [
                            {
                                sectionType: 'Container',
                                images: { image: [] },
                                properties: {
                                    columns: 1,
                                    containerPadding: '0px',
                                    itemsSpacing: '0px',
                                    border: false,
                                    borderColor: '#000',
                                    background: true,
                                    edgeToEdge: false,
                                    images: [],
                                    width: 21,
                                    row: 0,
                                    paddingLeft: true,
                                    paddingTop: true,
                                    paddingRight: true,
                                    paddingBottom: true,
                                    backgroundColor: 'rgba(255, 255, 255, 1)',
                                    minimumHeight: 200,
                                },
                                sections: [
                                    {
                                        sectionType: 'Text',
                                        text: { text: `<h1 class="pdc-text-center">${date.getDate()}</h1>` },
                                        documents: {},
                                        images: {},
                                        properties: {
                                            padding: '20px',
                                            color: 'rgba(255, 0, 0, 1)',
                                            paddingLeft: true,
                                            paddingTop: true,
                                            paddingRight: true,
                                            paddingBottom: true,
                                            style: 'standardHandwritten',
                                            row: 0,
                                            width: 100,
                                        },
                                        id: shortid(),
                                    },
                                    {
                                        sectionType: 'Text',
                                        text: { text: `<h4 class="pdc-text-center">${month} ${year}</h4>` },
                                        documents: {},
                                        images: {},
                                        properties: {
                                            padding: '20px',
                                            color: '#000',
                                            paddingLeft: true,
                                            paddingTop: true,
                                            paddingRight: true,
                                            paddingBottom: true,
                                            width: 100,
                                            row: 1,
                                            style: 'standardHandwritten',
                                        },
                                        id: shortid(),
                                    },
                                ],
                                id: shortid(),
                            },
                        ],
                        id: shortid(),
                    },
                    {
                        sectionType: 'Container',
                        images: { image: [] },
                        id: shortid(),
                        properties: {
                            columns: 1,
                            containerPadding: '0px',
                            itemsSpacing: '0px',
                            border: false,
                            borderColor: '#000',
                            background: false,
                            edgeToEdge: false,
                            images: [],
                            width: 100,
                            row: 1,
                            paddingLeft: true,
                            paddingTop: true,
                            paddingRight: true,
                            paddingBottom: true,
                        },
                        sections: [
                            {
                                sectionType: 'Text',
                                text: { text: `<h2 class="pdc-text-center">${collectionData.name}</h2>` },
                                documents: {},
                                images: {},
                                properties: {
                                    padding: '20px',
                                    color: '#000',
                                    paddingLeft: true,
                                    paddingTop: true,
                                    paddingRight: true,
                                    paddingBottom: true,
                                    width: 100,
                                    row: 0,
                                    style: 'standardBig',
                                },
                                id: shortid(),
                            },
                            {
                                sectionType: 'Text',
                                text: { text: `<p></p>` },
                                documents: {},
                                images: {},
                                properties: {
                                    padding: '0px',
                                    color: '#000',
                                    paddingLeft: true,
                                    paddingTop: true,
                                    paddingRight: true,
                                    paddingBottom: true,
                                    width: 100,
                                    row: 0,
                                    style: 'st',
                                },
                                id: shortid(),
                            },
                            {
                                sectionType: 'Spacer',
                                text: {},
                                documents: {},
                                images: {},
                                properties: {
                                    size: 's',
                                    border: false,
                                    borderColor: '#000',
                                    background: false,
                                    width: 100,
                                    row: 2,
                                },
                                id: shortid(),
                            },
                            this.createFileAndContentSectionsNew(collectionData.resources, language), //this.createFileAndContentSections(collectionData.resources, language),

                            {
                                sectionType: 'Spacer',
                                text: {},
                                documents: {},
                                images: {},
                                properties: {
                                    size: 'm',
                                    border: false,
                                    borderColor: '#000',
                                    background: false,
                                    width: 100,
                                    row: 2,
                                },
                                id: shortid(),
                            },
                            {
                                sectionType: 'Text',
                                text: { text: `<p></p>` },
                                documents: {},
                                images: {},
                                properties: {
                                    padding: '0px',
                                    color: '#000',
                                    paddingLeft: true,
                                    paddingTop: true,
                                    paddingRight: true,
                                    paddingBottom: true,
                                    width: 100,
                                    row: 0,
                                    style: 'st',
                                },
                                id: shortid(),
                            },
                            {
                                sectionType: 'Spacer',
                                text: {},
                                documents: {},
                                images: {},
                                properties: {
                                    size: 's',
                                    border: false,
                                    borderColor: '#000',
                                    background: false,
                                    width: 100,
                                    row: 2,
                                },
                                id: shortid(),
                            },
                            {
                                sectionType: 'Gallery',
                                text: {},
                                documents: {},
                                images: {
                                    images: this.getAllImageIds(collectionData.resources),
                                },
                                properties: {
                                    size: 'cover',
                                    relativeSize: 'L',
                                    columnsWidth: '25%',
                                    align: 'left',
                                    contentAlign: 'center center',
                                    padding: '0px',
                                    carousel: false,
                                    width: 100,
                                    row: 11,
                                },
                                id: shortid(),
                            },
                        ],
                    },
                ],
            },
        ];
        console.log(JSON.stringify(sections));
        console.log(sections);
        return sections;
    };

    getAllImageIds = (resources) => {
        let imgIds = [];
        for (let i = 0; i < resources.length; i++) {
            let resource = resources[i];
            if (resource.resourceType === 'file' && resource.resourceSubtype === 'image') {
                imgIds.push(resource.resourceId);
            }
        }
        return imgIds;
    };

    createElementComponent = (resource, language) => {
        let id = shortid();
        let names = resource.title !== undefined ? resource.title : resource.names;
        let name = getLocalizedName(language, names);
        let fileId = resource.resourceId;
        let type = resource.resourceSubtype;
        let icon;
        let documentDefinition = {};
        if (resource.resourceType === 'file') {
            if (resource.resourceSubtype === 'image') {
                icon = ImageIcon;
            } else if (resource.resourceSubtype === 'video') {
                icon = VideoIcon;
            } else {
                icon = FileIcon;
            }
            documentDefinition = {
                fileId: fileId,
            };
        } else if (resource.resourceType === 'content') {
            let appContext = new AppContext();
            let config = appContext.getConfig();
            let platformId = appContext.getPlatformId();
            icon = ContentIcon;
            type = undefined; // remove
            documentDefinition = {
                url: `https://${platformId}.${config.PdcDomain}/${
                    resource.resourceSubtype === 'm' ? 'metadocument' : 'category'
                }/show/${fileId}`,
            };
        }
        return {
            id,
            type,
            name,
            element: {
                document: documentDefinition,
                icon: {
                    inverted: false,
                    name: icon,
                    padding: 5,
                    primaryColor: '#167D86',
                    size: '30px',
                },
                preview: resource.resourceImage,
            },
        };
    };

    createFileAndContentSectionsNew = (resources, language) => {
        let elements = [];
        for (let i = 0; i < resources.length; i++) {
            let resource = resources[i];
            console.log(resource);
            if (!(resource.resourceType === 'file' && resource.resourceSubtype === 'image')) {
                elements.push(this.createElementComponent(resource, language));
            }
        }
        let text = {};
        let order = [];
        let fileTypes = {};
        let documents = {};
        for (let e of elements) {
            text[e.id] = `<p>${e.name}</p>`;
            order.push(e.id);
            fileTypes[e.id] = e.type;
            documents[e.id] = e.element;
        }

        const section = {
            sectionType: 'MediaGallery',
            text,
            documents,
            properties: {
                style: 'st',
                layout: 'inline',
                align: 'left',
                columnsWidth: '25%',
                headerHeight: '500px',
                padding: '0px',
                iconSize: '30px',
                includePreview: true,
                previewStyle: 'cover',
                spacing: '5px',
                buttonsVerticalPosition: 'center',
                width: 100,
                row: 7,
                order,
                fileTypes,
                backgroundColor: 'rgba(214, 214, 214, 1)',
            },
            id: shortid(),
        };
        return section;
    };

    setContentSections = (modalType, contentId, language, contentData, version) => {
        let sections;
        if (modalType === 'mtg') {
            sections = this.createMTGSectionStructure(contentData, language);
        } else {
            sections = this.createCOLSectionStructure(contentData, language);
        }
        return ContentService.setContentSections(contentId, language, undefined, sections, version);
    };

    setContentSectionsFromCollection = async (contentId, language, contentData, oldVersion) => {
        let version = oldVersion;
        let finalErrors = false;
        let langs = [language];
        let collection = contentData.collection;
        if (!collection) {
            // Si no es defineix collection es posa com a minim el header per no deixar el mtg en blanc
            this.setContentSections('mtg', undefined, contentId, language, contentData, oldVersion);
            return 'OK';
        }

        let date = contentData.date.toDate();
        let locale = language;
        let month = date.toLocaleString(locale, { month: 'long' });
        let year = date.getFullYear();

        let content = collection.content;
        Object.keys(content).forEach((lang) => {
            if (langs.indexOf(lang) === -1) {
                langs.push(lang);
            }
        });
        let name = contentData.name;

        for (let i = 0; i < langs.length; i++) {
            try {
                let currLang = langs[i];
                if (currLang !== language) {
                    //createContentLocalization
                    let locResponse = await ContentService.createContentLocalization(contentId, currLang, name);
                    version = locResponse.version;
                }

                let sections;
                if (content[currLang]) {
                    sections = content[currLang].sections;
                } else {
                    sections = content[collection.defaultLanguage].sections;
                }

                // es reemplaça el header per el de meeting
                sections[0].sections[0].sections = [
                    {
                        sectionType: 'Container',
                        images: { image: [] },
                        properties: {
                            columns: 1,
                            containerPadding: '0px',
                            itemsSpacing: '0px',
                            border: false,
                            borderColor: '#000',
                            background: true,
                            edgeToEdge: false,
                            images: [],
                            width: 21,
                            row: 0,
                            paddingLeft: true,
                            paddingTop: true,
                            paddingRight: true,
                            paddingBottom: true,
                            backgroundColor: 'rgba(255, 255, 255, 1)',
                            minimumHeight: 200,
                        },
                        sections: [
                            {
                                sectionType: 'Text',
                                text: { text: `<h1 class="pdc-text-center">${date.getDate()}</h1>` },
                                documents: {},
                                images: {},
                                properties: {
                                    padding: '20px',
                                    color: 'rgba(255, 0, 0, 1)',
                                    paddingLeft: true,
                                    paddingTop: true,
                                    paddingRight: true,
                                    paddingBottom: true,
                                    style: 'standardHandwritten',
                                    row: 0,
                                    width: 100,
                                },
                                id: shortid(),
                            },
                            {
                                sectionType: 'Text',
                                text: { text: `<h4 class="pdc-text-center">${month} ${year}</h4>` },
                                documents: {},
                                images: {},
                                properties: {
                                    padding: '20px',
                                    color: '#000',
                                    paddingLeft: true,
                                    paddingTop: true,
                                    paddingRight: true,
                                    paddingBottom: true,
                                    width: 100,
                                    row: 1,
                                    style: 'standardHandwritten',
                                },
                                id: shortid(),
                            },
                        ],
                        id: shortid(),
                    },
                ];

                //setMetadocumentSections
                let sectionsResponse = await ContentService.setContentSections(contentId, currLang, undefined, sections, version);
                version = sectionsResponse.version;
            } catch (err) {
                finalErrors = true;
                console.log(err);
            }
        }
        if (finalErrors) {
            throw new Error('Errors occured during sections creation');
        } else {
            return 'OK';
        }
    };
}

export default MeetingsAndCollectionsController;
